export enum MediaItemType {
  LC_SUBITEM = "lc-subitem",
  REGULAR_ITEM = "regular-item",
}
